<template>
  <div id="app">
    <router-view class="view"></router-view>
    <thread-sidebar/>
  </div>
</template>

<script>
import ThreadSidebar from "./components/sidebars/ThreadSidebar";

export default {
  name: "App",
  components: {ThreadSidebar}
}
</script>

<style>
/* global transitions */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* global icon size between regular and large */
.fas.fa-md {
  font-size: 1.2em;
  line-height: 0.70em;
}

.box.is-clickable {
  transition: all 200ms;
}
.box.is-clickable:hover {
	-webkit-box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.2), 0 0px 0 1px rgba(10, 10, 10, 0.08);
	box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.2), 0 0px 0 1px rgba(10, 10, 10, 0.08);
}

</style>
